import { BaseModel } from "../../normalized/models";

export class ProductRate extends BaseModel {
    id: string;
    price: number;
    date: string;
}
